import Vue from 'vue';
import { initI18n } from './initVueI18n';

export function startMixin (App) {
  /**
   * Starts up the app
   * @returns {Promise<Hammer>}
   */
  App.prototype.start = function () {
    return initI18n(this).then(() => Promise.resolve(this));
  };

  /**
   * Starts the app and creates a Vue instance.
   * @param options
   * @returns {Promise<Vue>}
   */
  App.prototype.startVue = function (options) {
    return this.start().then(({ router, i18n }) => {
      return new Vue(Object.assign({
        router,
        i18n
      }, options));
    });
  };
}
